import { render, staticRenderFns } from "./OrgLicenseCounter.vue?vue&type=template&id=36be4428&"
import script from "./OrgLicenseCounter.vue?vue&type=script&lang=js&"
export * from "./OrgLicenseCounter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports